import { render, staticRenderFns } from "./TransferComplete.vue?vue&type=template&id=fb9b4162&scoped=true"
import script from "./TransferComplete.vue?vue&type=script&lang=ts"
export * from "./TransferComplete.vue?vue&type=script&lang=ts"
import style0 from "./TransferComplete.vue?vue&type=style&index=0&id=fb9b4162&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb9b4162",
  null
  
)

export default component.exports